import { Box, Grid, Typography } from '@mui/material'
import React from 'react'

const GreenHouseBox = ({phone}) => {
  return (
   
    <Grid container  display={"flex"} justifyContent={"space-around"}  alignItems={phone ?"center" :"flex-start"} width={"100%"} p={phone ?'5% 20px' :'5% 20px'} flexDirection={phone?"column":'row'} flexWrap={"wrap"} bgcolor={"#000"} >
        <Grid item lg={7} xl={7} md={7} sm={12} xs={12} display={"flex"} flexDirection={"column"} alignItems={"center"} gap={phone?5:4}>
            {phone&&
                <Box display={"flex"} flexDirection={"column"} gap={2} width={"100%"} data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="1000">
                    <Typography  textAlign={"center"} color='#fff' fontSize={phone?"30px":"48px"} fontWeight={900} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-duration="2000" >گلخانه ی مکانیزه جان اسنک نگرشی متفاوت</Typography>
                    <Typography  textAlign={"center"} color='#fff' data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-duration="1000">   بخشی از زنجیره تامین جان اسنک</Typography>
                </Box>
            }
            <Box position={"relative"} width={"100%"}  height={phone?"329px":"390px"} overflow={"hidden"}>
                <img src="/images/103.jpg" alt="" style={{borderRadius:'50px',position:'absolute'}} width={"100%"} height={"100%"} />
                <img src="/images/greenhouse.jpg" className='reveal' width={"100%"} alt=""    />
            </Box>
            {phone&&
                <Box position={"relative"} overflow={"hidden"} height="517px" width={phone?"100%":"356px"}>
                    <img src="/images/102.jpg" alt=""  style={{borderRadius:'50px',position:'absolute',height:'100%'}}width={phone?"100%":"356px"} />
                    <img src="/images/g3.jpg" className='reveal' alt="" width={phone?"100%":"356px"}  />
                </Box>
            }
            <Grid item lg={12} xl={12} md={12} sm={12}  width={"100%"} display={"flex"}  justifyContent={"space-between"} position={"relative"} height={phone?"400px":"300px"} gap={3}flexDirection={phone?"column":"row"} alignItems={"center"}>
                <Grid item lg={6} xl={6} md={6} sm={12} xs={12}   width={"100%"} height={phone?"193px":'250px'} position={"relative"} overflow={"hidden"}>
                    <img src="/images/101.jpg" alt="" height={"100%"} style={{borderRadius:'50px',position:'absolute'}}  width={"100%"}/>
                    <img src="/images/g2.jpg" height={"100%"} className='reveal' alt=""   width={"100%"}/>
                </Grid>
                <Grid item lg={6} xl={6} md={6} sm={12} xs={12}  width={"100%"} height={phone?"193px":'250px'}  position={"relative"} overflow={"hidden"}>
                    <img src="/images/Zr6xu4xq1jF7hLENb2aNtO9jsD7DS6GLZMw24RPF.jpg" height={"100%"}  width={"100%"} alt="" style={{borderRadius:'50px',position:'absolute'}}/>
                    <img src="/images/g1.jpg" className='reveal' alt=""   height={"100%"}  width={"100%"} />
                </Grid>
            </Grid>
        </Grid> 
    {!phone &&
        <Grid item lg={3.5} xl={3.5} md={3.5} sm={12} xs={12} display={"flex"} flexDirection={"column"} gap={6}  >
            <Box display={"flex"} flexDirection={"column"} gap={2}>
                <h3 style={{minWidth:'300px',color:'#fff',maxWidth:'100%'}}>  گلخانه ی مکانیزه جان اسنک نگرشی متفاوت  </h3>
                <h6 style={{color:'#fff'}}> بخشی از زنجیره تامین جان اسنک </h6>
            </Box>
            <Box position={"relative"} overflow={"hidden"} height="500px" width={"100%"}>
              <img src="/images/102.jpg" alt=""  style={{borderRadius:'50px',position:'absolute',height:'100%',width:'100%'}}width={"356px"} />
              <img src="/images/g3.jpg" className='reveal' alt="" width={"100%"}  />
            </Box>
        </Grid>
    }            
</Grid>
        
  )
}

export default GreenHouseBox